<div
    *ngIf="isOpened"
    class="tesla-sidebar"
    [@slideIn]="position"
    [ngClass]="position === 'left' ? 'left' : 'right'"
    [style.width]="width"
>
    <div class="sidebar-header">
        <h2 class="sidebar-title">{{translate.get(title)}}</h2>
        <i class="material-icons sidebar-close-btn" (click)="close()">close</i>
    </div>
    <div class="sidebar-body">
        <ng-content></ng-content>
    </div>
</div>
<div *ngIf="isOpened" class="sidebar-overlay" (click)="close()"></div>

<span hidden i18n="@@UnsavedInformation" t="UnsavedInformation">Unsaved Information</span>
<span
    hidden
    i18n="@@UnsavedChanges"
    t="UnsavedChanges"
    >There are unsaved changes. Are you sure you want to proceed?</span
>
<span hidden i18n="@@OK" t="OK">OK</span>
<span hidden i18n="@@Cancel" t="Cancel">Cancel</span>
